// Copyright ©️ 2026 eVolve MEP, LLC

import type { BendTypeName } from '@evolvemep/api-ts';

import { Kick90BackToBackGeometry } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendGeometries/Kick90BackToBackGeometry';
import { Offset90BackToBackGeometry } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendGeometries/Offset90BackToBackGeometry';
import { YBCGeometry } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/BendGeometries/YBCGeometry';

import { AngledGeometry } from './BendGeometries/AngledGeometry';
import { FourPointSaddleGeometry } from './BendGeometries/FourPointSaddleGeometry';
import { Kick90Geometry } from './BendGeometries/Kick90Geometry';
import { OffsetGeometry } from './BendGeometries/OffsetGeometry';
import { Stub90Geometry } from './BendGeometries/Stub90Geometry';
import { ThreePointSaddleGeometry } from './BendGeometries/ThreePointSaddleGeometry';
import type { BendPreviewGeometry } from './BendPreviewGeometry';

/** Maps each bend type name to a factory that creates its geometry. */
const bendTypeLookup: Record<BendTypeName, () => BendPreviewGeometry> = {
  'Stub 90': () => new Stub90Geometry(),
  'Offset': () => new OffsetGeometry(),
  'Kick 90 Left': () => new Kick90Geometry('left'),
  'Kick 90 Right': () => new Kick90Geometry('right'),
  'Angled': () => new AngledGeometry(),
  '3-Point Saddle': () => new ThreePointSaddleGeometry(),
  '4-Point Saddle': () => new FourPointSaddleGeometry(),
  'Offset Back to Back': () => new Offset90BackToBackGeometry(),
  'Kick 90 Back to Back Right': () => new Kick90BackToBackGeometry('right'),
  'Kick 90 Back to Back Left': () => new Kick90BackToBackGeometry('left'),
  'Custom': () => new YBCGeometry(),
};

export const getBendPreview = (bendType: BendTypeName): BendPreviewGeometry => bendTypeLookup[bendType]();
